export default "__VITE_ASSET__Rxf1vvwu__"